import { Component, Input, OnInit } from '@angular/core';
import { CentroSaludCercano } from 'src/app/model/ReglamentoInterno.model';

@Component({
  selector: 'app-centros-salud-cercanos-reglamento',
  templateUrl: './centros-salud-cercanos-reglamento.component.html',
  styleUrls: ['./centros-salud-cercanos-reglamento.component.css']
})
export class CentrosSaludCercanosReglamentoComponent implements OnInit {

  @Input() centroSaludCercano : CentroSaludCercano;
  @Input() readonly : boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
